export default __webpack_public_path__ + "cddd3ebbc21481740c24d1b87178d353.png";